<ion-accordion-group #accordionGroup [multiple]="true" [value]="this.initialGroupValue">
  <ng-content></ng-content>
</ion-accordion-group>
